<template>
  <div class="integration-panel">
    <div class="row">
      <div class="col-4">
        <div class="text-center integration-logo-container">
          <img alt="image" class="rounded-circle img-fluid integration-logo" :src="'/glass/integrations/' + image">
        </div>
      </div>
      <div class="col-8">
        <span class="float-right status-active mt-1" v-if="installed">
          <i class="far fa-lg fa-check-circle"> </i> Connected
        </span>
        <h3><strong>{{name}}</strong></h3>
        <p class="integration-panel-description">{{description}}</p>
        <div class="row mt-2">
          <div class="col-6">
            <FormButton class="btn-default" @click="onConfigClicked" v-if="installed && userHasUpdatePermission(PermissionTypes.AdminPermissionTypes.integration)"><i class="far fa-cog"> </i> Configuration</FormButton>
          </div>
          <div class="col-6 text-right" v-if="userHasUpdatePermission(PermissionTypes.AdminPermissionTypes.integration)">
            <FormButton class="btn-primary" @click="onConnectClicked" v-if="!installed"><i class="far fa-plus-circle"> </i> Connect</FormButton>
            <FormButton class="btn-danger" @click="onDisconnectClicked" v-if="installed"><i class="far fa-minus-circle"> </i> Disconnect</FormButton>
          </div>          
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.integration-panel {
  background-color: #ffffff;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: $layout-minor-border-radius;
}
.integration-panel-description {
  min-height: 50px;
  margin-bottom: 5px;
}
.integration-logo-container {
  line-height: 128px;
  vertical-align: middle;
}
.integration-logo {
  max-width: 128px;
  max-height: 128px;
}
</style>

<script>
export default {
  name: "IntegrationPanel",
  props: {
    name: String,
    code: String,
    description: String,
    image: String,
    installed: Boolean,
    enabled: Boolean,
    configEnabled: Boolean
  },
  data: () => {
    return {
    }    
  },
  methods: {
    onConnectClicked(e) {
      this.$emit('connect', e)
    },
    onDisconnectClicked(e) {
      this.$emit('disconnect', e)
    },
    onConfigClicked(e) {
      this.$emit('config', e)
    }
  }
}
</script>
